import api from '@/lib/api';

// Single source for SmartoERP PLATFORM identity on pre-auth/platform surfaces
// (web login, Cashier/Waiter PIN screens). Reads the central, super-admin
// controlled /platform-branding/public. The bundled static asset is used ONLY
// as a fallback when the central source has no logo or cannot load.
export const PLATFORM_FALLBACK = {
  app_name: 'SmartoERP',
  logo_url: '',
  favicon_url: '',
};
export const STATIC_PLATFORM_LOGO = '/smarto-logo-main.png';

let cache = null;

// Resolve a stored (relative) logo URL to an absolute, browser-usable src.
export function platformLogoSrc(branding) {
  const url = branding?.logo_url;
  if (!url) return STATIC_PLATFORM_LOGO;
  if (/^https?:\/\//i.test(url)) return url;
  return `${process.env.REACT_APP_BACKEND_URL || ''}${url}`;
}

export async function getPlatformBranding() {
  if (cache) return cache;
  try {
    const { data } = await api.get('/platform-branding/public');
    cache = { ...PLATFORM_FALLBACK, ...(data || {}) };
  } catch {
    cache = { ...PLATFORM_FALLBACK };
  }
  return cache;
}
